// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*----------------------------------------------------------
  Carousel Banner Variables
----------------------------------------------------------*/
:host {
  --banner-max-height-sm: 320px;
  --banner-max-height-md: 400px;
  --banner-max-height-lg: 400px;
  --indicator-active-color: var(--ion-color-secondary);
  --indicator-inactive-color: var(--ion-color-light-shade);
}

/*----------------------------------------------------------
  Carousel Container
----------------------------------------------------------*/
.carousel-container {
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  height: auto;
  /*--------------------------------------------------------
    Wrapper & Items
  --------------------------------------------------------*/
  /*--------------------------------------------------------
    Nav Buttons
  --------------------------------------------------------*/
  /*--------------------------------------------------------
    Indicators
  --------------------------------------------------------*/
}
.carousel-container .carousel-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  cursor: pointer;
  will-change: transform;
  transition-property: transform;
  transition-duration: 500ms;
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  transition-delay: 100ms;
}
.carousel-container .carousel-item {
  flex: 0 0 100%;
  height: auto;
  overflow: hidden;
  backface-visibility: hidden;
}
.carousel-container .nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  padding: 0.6rem;
  background: var(--ion-color-secondary);
  color: var(--ion-color-light);
  border: none;
  cursor: pointer;
  opacity: 0.8;
  z-index: 10;
  transition: opacity 0.2s ease;
}
.carousel-container .nav-button:hover {
  opacity: 1;
}
.carousel-container .nav-button .button-icon {
  font-size: 3rem;
  line-height: 1;
}
.carousel-container .nav-button.prev {
  left: 0.5rem;
}
.carousel-container .nav-button.next {
  right: 0.5rem;
}
@media (max-width: 768px) {
  .carousel-container .nav-button {
    padding: 0.4rem;
  }
  .carousel-container .nav-button .button-icon {
    font-size: 2rem;
  }
}
.carousel-container .indicators {
  height: fit-content;
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.5rem;
  z-index: 10;
}
.carousel-container .indicators span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--indicator-inactive-color);
  cursor: pointer;
  transition: transform 0.3s ease, background 0.3s ease;
}
.carousel-container .indicators span:hover, .carousel-container .indicators span.active {
  transform: scale(1.2);
}
.carousel-container .indicators span.active {
  background: var(--indicator-active-color);
}
@media (max-width: 768px) {
  .carousel-container .indicators span {
    width: 10px;
    height: 10px;
  }
}

/*----------------------------------------------------------
  Category Bar Scroll Buttons
----------------------------------------------------------*/
.categorybar__scrollbutton {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
}
.categorybar__scrollbutton::after {
  content: "";
  position: absolute;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--ion-color-light);
}
@media screen and (max-width: 576px) {
  .categorybar__scrollbutton::after {
    height: 30px;
    width: 30px;
  }
}
.categorybar__scrollbutton ion-icon {
  z-index: 1;
  font-size: 2rem;
}
@media screen and (max-width: 576px) {
  .categorybar__scrollbutton ion-icon {
    font-size: 1.5rem;
  }
}
.categorybar__scrollbutton--left {
  left: 5px;
}
.categorybar__scrollbutton--left ion-icon {
  margin-left: -3px;
}
.categorybar__scrollbutton--right {
  right: 5px;
}
.categorybar__scrollbutton--right ion-icon {
  margin-right: -3px;
}

/*----------------------------------------------------------
  Banner Image Fit
----------------------------------------------------------*/
.banner-style {
  width: 100%;
  display: block;
  position: relative;
}
.banner-style img {
  width: 100%;
  height: auto;
  /* Tablet */
  /* Desktop */
  object-fit: cover;
  object-position: center;
  display: block;
  background: var(--ion-color-casino);
}
@media screen and (max-width: 576px) {
  .banner-style img {
    max-height: var(--banner-max-height-sm);
    aspect-ratio: 750/320;
  }
}
@media (min-width: 577px) and (max-width: 992px) {
  .banner-style img {
    max-height: var(--banner-max-height-md);
    aspect-ratio: 1080/400;
  }
}
@media (min-width: 993px) {
  .banner-style img {
    aspect-ratio: 1900/400;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/carousel/carousel.component.scss"],"names":[],"mappings":"AAAA;;2DAAA;AAGA;EAEE,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,oDAAA;EACA,wDAAA;AAAF;;AAGA;;2DAAA;AAGA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;EAEA;;2DAAA;EAuBA;;2DAAA;EA0CA;;2DAAA;AA1DF;AAJE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gEAAA;EACA,uBAAA;AAMJ;AAFE;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;AAIJ;AAEE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,sCAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;AAAJ;AAEI;EACE,UAAA;AAAN;AAGI;EACE,eAAA;EACA,cAAA;AADN;AAII;EACE,YAAA;AAFN;AAKI;EACE,aAAA;AAHN;AAMI;EA9BF;IA+BI,eAAA;EAHJ;EAKI;IACE,eAAA;EAHN;AACF;AAUE;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;AARJ;AAUI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,eAAA;EACA,qDAAA;AARN;AAUM;EAEE,qBAAA;AATR;AAYM;EACE,yCAAA;AAVR;AAcM;EAlBF;IAmBI,WAAA;IACA,YAAA;EAXN;AACF;;AAgBA;;2DAAA;AAGA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;AAbF;AAiBE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;AAfJ;AAiBI;EARF;IAUI,YAAA;IACA,WAAA;EAfJ;AACF;AAmBE;EACE,UAAA;EACA,eAAA;AAjBJ;AAmBI;EAJF;IAKI,iBAAA;EAhBJ;AACF;AAqBE;EACE,SAAA;AAnBJ;AAqBI;EACE,iBAAA;AAnBN;AAuBE;EACE,UAAA;AArBJ;AAuBI;EACE,kBAAA;AArBN;;AA0BA;;2DAAA;AAGA;EACE,WAAA;EAEA,cAAA;EACA,kBAAA;AAxBF;AA2BE;EACE,WAAA;EACA,YAAA;EAQA,WAAA;EAMA,YAAA;EAMA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,mCAAA;AA1CJ;AAqBI;EAJF;IAKI,uCAAA;IAEA,qBAAA;EAnBJ;AACF;AAsBI;EAXF;IAYI,uCAAA;IACA,sBAAA;EAnBJ;AACF;AAsBI;EAjBF;IAmBI,sBAAA;EApBJ;AACF","sourcesContent":["/*----------------------------------------------------------\r\n  Carousel Banner Variables\r\n----------------------------------------------------------*/\r\n:host {\r\n\r\n  --banner-max-height-sm: 320px;\r\n  --banner-max-height-md: 400px;\r\n  --banner-max-height-lg: 400px;\r\n  --indicator-active-color: var(--ion-color-secondary);\r\n  --indicator-inactive-color: var(--ion-color-light-shade);\r\n}\r\n\r\n/*----------------------------------------------------------\r\n  Carousel Container\r\n----------------------------------------------------------*/\r\n.carousel-container {\r\n  position: relative;\r\n  overflow-x: hidden;\r\n  overflow-y: hidden;\r\n  width: 100%;\r\n  user-select: none;\r\n  height: auto;\r\n\r\n  /*--------------------------------------------------------\r\n    Wrapper & Items\r\n  --------------------------------------------------------*/\r\n  .carousel-wrapper {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    cursor: pointer;\r\n    will-change: transform;\r\n    transition-property: transform;\r\n    transition-duration: 500ms;\r\n    transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition-delay: 100ms;\r\n\r\n  }\r\n\r\n  .carousel-item {\r\n    flex: 0 0 100%;\r\n    height: auto;\r\n    overflow: hidden;\r\n    backface-visibility: hidden;\r\n  }\r\n\r\n  /*--------------------------------------------------------\r\n    Nav Buttons\r\n  --------------------------------------------------------*/\r\n  .nav-button {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    padding: 0.6rem;\r\n    background: var(--ion-color-secondary);\r\n    color: var(--ion-color-light);\r\n    border: none;\r\n    cursor: pointer;\r\n    opacity: 0.8;\r\n    z-index: 10;\r\n    transition: opacity 0.2s ease;\r\n\r\n    &:hover {\r\n      opacity: 1;\r\n    }\r\n\r\n    .button-icon {\r\n      font-size: 3rem;\r\n      line-height: 1;\r\n    }\r\n\r\n    &.prev {\r\n      left: 0.5rem;\r\n    }\r\n\r\n    &.next {\r\n      right: 0.5rem;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 0.4rem;\r\n\r\n      .button-icon {\r\n        font-size: 2rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  /*--------------------------------------------------------\r\n    Indicators\r\n  --------------------------------------------------------*/\r\n  .indicators {\r\n    height: fit-content;\r\n    position: absolute;\r\n    bottom: 1rem;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    z-index: 10;\r\n\r\n    span {\r\n      width: 12px;\r\n      height: 12px;\r\n      border-radius: 50%;\r\n      background: var(--indicator-inactive-color);\r\n      cursor: pointer;\r\n      transition: transform 0.3s ease, background 0.3s ease;\r\n\r\n      &:hover,\r\n      &.active {\r\n        transform: scale(1.2);\r\n      }\r\n\r\n      &.active {\r\n        background: var(--indicator-active-color);\r\n\r\n      }\r\n\r\n      @media (max-width: 768px) {\r\n        width: 10px;\r\n        height: 10px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/*----------------------------------------------------------\r\n  Category Bar Scroll Buttons\r\n----------------------------------------------------------*/\r\n.categorybar__scrollbutton {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  margin: auto 0;\r\n  width: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  z-index: 1;\r\n\r\n\r\n\r\n  &::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 44px;\r\n    height: 44px;\r\n    border-radius: 50%;\r\n    background: var(--ion-color-light);\r\n\r\n    @media screen and (max-width: 576px) {\r\n\r\n      height: 30px;\r\n      width: 30px;\r\n    }\r\n\r\n  }\r\n\r\n  ion-icon {\r\n    z-index: 1;\r\n    font-size: 2rem;\r\n\r\n    @media screen and (max-width: 576px) {\r\n      font-size: 1.5rem;\r\n\r\n    }\r\n\r\n  }\r\n\r\n  &--left {\r\n    left: 5px;\r\n\r\n    ion-icon {\r\n      margin-left: -3px;\r\n    }\r\n  }\r\n\r\n  &--right {\r\n    right: 5px;\r\n\r\n    ion-icon {\r\n      margin-right: -3px;\r\n    }\r\n  }\r\n}\r\n\r\n/*----------------------------------------------------------\r\n  Banner Image Fit\r\n----------------------------------------------------------*/\r\n.banner-style {\r\n  width: 100%;\r\n\r\n  display: block;\r\n  position: relative;\r\n\r\n\r\n  img {\r\n    width: 100%;\r\n    height: auto;\r\n\r\n    @media screen and (max-width: 576px) {\r\n      max-height: var(--banner-max-height-sm);\r\n\r\n      aspect-ratio: 750/320;\r\n    }\r\n\r\n    /* Tablet */\r\n    @media (min-width: 577px) and (max-width: 992px) {\r\n      max-height: var(--banner-max-height-md);\r\n      aspect-ratio: 1080/400;\r\n    }\r\n\r\n    /* Desktop */\r\n    @media (min-width: 993px) {\r\n      // max-height: var(--banner-max-height-lg);\r\n      aspect-ratio: 1900/400;\r\n    }\r\n\r\n    object-fit: cover;\r\n    object-position: center;\r\n    display: block;\r\n    background: var(--ion-color-casino);\r\n    // background: var(--ion-color-additional);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
